import { render, staticRenderFns } from "./girlsInfo.vue?vue&type=template&id=5c182484&scoped=true"
import script from "./girlsInfo.vue?vue&type=script&lang=js"
export * from "./girlsInfo.vue?vue&type=script&lang=js"
import style0 from "./girlsInfo.vue?vue&type=style&index=0&id=5c182484&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c182484",
  null
  
)

export default component.exports